import React from 'react';
import { Tooltip } from 'react-tooltip';

import type { ILanguage } from '../../model/languagesList';
import { useManageTranslationsActions } from '../../store/useManageTranslationsStore';
import style from './style.module.scss';

interface IProps {
  languages: ILanguage[];
  id: string;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const SelectLanguageMenu: React.FC<IProps> = ({ languages, id, isOpen, setIsOpen }) => {
  const { setManageTranslationsSelectedLanguage } = useManageTranslationsActions();

  return (
    <Tooltip
      id={id}
      place="bottom-end"
      openOnClick
      className={style.selectLanguageMenuPopover}
      clickable
      disableStyleInjection
      isOpen={isOpen}
      setIsOpen={(isOpen) => setIsOpen(isOpen)}
      noArrow
      render={() => {
        return (
          <>
            {languages.map((language) => (
              <div
                className={style.selectLanguageMenuPopoverItem}
                onClick={() => {
                  setManageTranslationsSelectedLanguage(language);
                  setIsOpen(false);
                }}
                key={language.id}
              >
                {language.name}
              </div>
            ))}
          </>
        );
      }}
    />
  );
};

export default SelectLanguageMenu;
